module.exports = __webpack_public_path__ + "static/tictactoe-c159f5c1ff3ca39c52cdd7bde77e45d7.png";